import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Solution() {
  return <section className="w-full bg-[var(--bg-dark)] py-20 px-4" data-id="element-137">
      <div className="max-w-4xl mx-auto text-center" data-id="element-138">
        <motion.h2 className="text-3xl md:text-4xl font-bold text-[var(--text-light)] mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          La Diferencia Entre Fracasar y Vender
        </motion.h2>

        <motion.p className="text-xl md:text-2xl text-[var(--text-gray)] mb-6" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-140">
          Imagina intentar cocinar sin receta exacta.
        </motion.p>

        <motion.p className="text-xl md:text-2xl text-[var(--text-gray)] mb-6" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} data-id="element-141">
          Un poco más de esto. Un poco menos de aquello. "Más o menos" así.
        </motion.p>

        <motion.p className="text-xl md:text-2xl text-[var(--text-light)] font-bold mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-142">
          Eso es exactamente lo que pasa con la mayoría de tutoriales de
          jabones.
        </motion.p>

        <motion.div className="bg-[var(--bg-darker)] p-8 md:p-12 rounded-2xl border-2 border-[var(--accent-orange)] mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} data-id="element-143">
          <p className="text-2xl md:text-3xl text-[var(--text-light)] font-bold mb-6" data-id="element-144">
            Pero cuando tienes fórmulas exactas, medidas claras y un sistema
            estructurado…
          </p>
          <p className="text-3xl md:text-4xl text-[var(--accent-orange)] font-black" data-id="element-145">
            Todo cambia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-146">
          <h3 className="text-2xl md:text-3xl font-bold text-[var(--text-light)] mb-6" data-id="element-147">
            Te Presento:
          </h3>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-[var(--accent-orange)] mb-8" data-id="element-148">
            MÉTODO JABONES
            <br data-id="element-149" />
            ARTESANALES
          </h2>
          <p className="text-xl md:text-2xl text-[var(--text-light)] mb-4" data-id="element-150">
            Un sistema paso a paso con:
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[var(--accent-orange-light)] mb-4" data-id="element-151">
            27 Recetas Probadas
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[var(--accent-orange-light)] mb-8" data-id="element-152">
            12 Fórmulas Profesionales
          </p>
          <p className="text-xl md:text-2xl text-[var(--text-gray)] mb-12" data-id="element-153">
            Y un Plan Claro para Empezar Desde Cero
            <br data-id="element-154" />
            <span className="text-[var(--text-light)] font-semibold" data-id="element-155">
              Sin experiencia previa. Sin adivinar. Sin desperdiciar materiales.
            </span>
          </p>

          <CTAButton size="large" data-id="element-156">ACCEDER AL MÉTODO</CTAButton>
        </motion.div>
      </div>
    </section>;
}